import { reactive } from "vue";

export const posterStore = reactive({
  url: ''
})

export const setPoster = (poster: string) => {
  posterStore.url = poster;
}